module.exports = __webpack_public_path__ + "img/erp-logos_0023_pepperi.ac2bb1a9.jpg";